<template>
  <div class='technology-assets-amount-table-cell'>
    <span class="amount" @click='toggleAssetsListPopup(item)'>{{ assetsAmount }}</span>
  </div>
</template>

<script>
export default {
  name: 'TechnologyAssetsAmountTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assetsListPopup: false,
    };
  },
  methods: {
    toggleAssetsListPopup(tech) {
      this.$emit('toggleAssetsListPopup', tech);
    },
  },
  computed: {
    assetsAmount() {
      return this.item[this.column.field] ? this.item[this.column.field] : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.technology-assets-amount-table-cell {
  width: 100%;
  display: flex;
  justify-content: center;

  .amount {
    z-index: 3;
    color: var(--text-primary);
    font-family: $font-family-semibold;
    font-size: $font-size-base;
    letter-spacing: 0;
    line-height: rem(17);
    font-weight: 600;

    &:hover {
      color: var(--brand-primary);
      text-decoration: var(--brand-primary) underline;
      cursor: pointer;
    }
  }
}
</style>
